<template>
  <div>
    <layout-panel>
      <span slot="header">审批人</span>
      <el-form ref="reviewInfoform"
               :model="form"
               :rules="formRules"
               size="medium"
               label-width="140px">
        <div class="re-el-form__flex">
          <div class="medium">
            <template v-if="!onlyShowCC">
            <el-form-item label="部门领导审批："
                          prop="department_approver">
              <remote-select
                class="width-max"
                clearable
                id-key="id"
                keyword-key="name"
                label-key="name"
                value-key="id"
                placeholder="请输入部门领导审批"
                v-model="form.department_approver"
                :query-request="(_)=>getPlatformUsersIndex(Object.assign(_, {usertype: [1, 2, 3, 4, 5], status_lists: [1, 2]}))"
                :find-request="getPlatformUsersDetail">
                </remote-select>
            </el-form-item>
            <el-form-item v-if="totalAmount > approverBoundaryValues.approve_amount_lv1" label="一级审批："
                          prop="first_approver">
              <remote-select
                class="width-max"
                clearable
                id-key="id"
                keyword-key="name"
                label-key="name"
                value-key="id"
                placeholder="请输入一级审批员名称搜索"
                v-model="form.first_approver"
                :query-request="(_)=>getPlatformUsersIndex(Object.assign(_, {usertype: [1, 2, 3, 4, 5], status_lists: [1, 2]}))"
                :find-request="getPlatformUsersDetail">
                </remote-select>
            </el-form-item>
            <el-form-item v-if="totalAmount > approverBoundaryValues.approve_amount_lv2" label="二级审批："
                          prop="second_approver">
              <remote-select
                class="width-max"
                clearable
                id-key="id"
                keyword-key="name"
                label-key="name"
                value-key="id"
                placeholder="请输入二级审批员名称搜索"
                v-model="form.second_approver"
                :query-request="(_)=>getPlatformUsersIndex(Object.assign(_, {usertype: [1, 2, 3, 4, 5], status_lists: [1, 2]}))"
                :find-request="getPlatformUsersDetail">
                </remote-select>
            </el-form-item>
            <el-form-item v-if="totalAmount > approverBoundaryValues.approve_amount_lv3" label="三级审批："
                          prop="third_approver">
              <remote-select
                class="width-max"
                clearable
                id-key="id"
                keyword-key="name"
                label-key="name"
                value-key="id"
                placeholder="请输入三级审批员名称搜索"
                v-model="form.third_approver"
                :query-request="(_)=>getPlatformUsersIndex(Object.assign(_, {usertype: [1, 2, 3, 4, 5], status_lists: [1, 2]}))"
                :find-request="getPlatformUsersDetail">
                </remote-select>
            </el-form-item>
            <el-form-item v-if="totalAmount > approverBoundaryValues.approve_amount_lv4" label="四级审批："
                          prop="fourth_approver">
              <remote-select
                class="width-max"
                clearable
                id-key="id"
                keyword-key="name"
                label-key="name"
                value-key="id"
                placeholder="请输入四级审批员名称搜索"
                v-model="form.fourth_approver"
                :query-request="(_)=>getPlatformUsersIndex(Object.assign(_, {usertype: [1, 2, 3, 4, 5], status_lists: [1, 2]}))"
                :find-request="getPlatformUsersDetail">
                </remote-select>
            </el-form-item>
            <el-form-item v-if="form.is_urgent" label="特批审批："
                          prop="special_approver">
              <remote-select
                class="width-max"
                clearable
                id-key="id"
                keyword-key="name"
                label-key="name"
                value-key="id"
                placeholder="请选择特批审批人，小零为Irene"
                v-model="form.special_approver"
                :query-request="(_)=>getPlatformUsersIndex(Object.assign(_, {usertype: [1, 2, 3, 4, 5], status_lists: [1, 2]}))"
                :find-request="getPlatformUsersDetail">
                </remote-select>
            </el-form-item>
            </template>
            <el-form-item label="抄送人："
                          prop="cc">
              <remote-select
                class="width-max"
                multiple
                clearable
                id-key="id"
                keyword-key="name"
                label-key="name"
                value-key="id"
                placeholder="请输入抄送人名称搜索"
                v-model="form.cc"
                :query-request="(_)=>getPlatformUsersIndex(Object.assign(_, {usertype: [1, 2, 3, 4, 5], status_lists: [1, 2]}))"
                :find-request="getPlatformUsersDetail">
                </remote-select>
            </el-form-item>
          </div>
        </div>
      </el-form>
    </layout-panel>
  </div>
</template>

<script>

import { reviewInfoformRules } from '../payment-manager.rules'
export default {
  props: {
    form: {
      type: Object,
      default: () => {}
    },
    totalAmount: {
      type: Number,
      default: 0
    },
    approverBoundaryValues: {
      type: Object,
      default: () => {}
    },
    onlyShowCC: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      formRules: reviewInfoformRules
    }
  },
  methods: {
    ...request.map([
      'getPlatformUsersIndex',
      'getPlatformUsersDetail',
    ]),
  },
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/payment-manager/components/PaymentApproverForm.vue